import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeTaken',
  standalone: false,
})
export class TimeTakenPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    // TimeSpan is usually HH:mm:ss, but tolerate mm:ss values too.
    const timeElements: string[] = value.split(':');
    const minutes =
      timeElements.length >= 3 ? timeElements[1] : (timeElements[0] ?? '00');
    const seconds = (
      timeElements.length >= 3 ? timeElements[2] : timeElements[1]
    )
      ?.substring(0, 2)
      .padStart(2, '0');

    if (minutes === '00' && seconds === '00') {
      return '--:--';
    }

    return `${minutes}:${seconds ?? '00'}`;
  }
}
